import CardActions3D from "domains/assets/components/CardActions/3D";
import CardActionsImage from "domains/assets/components/CardActions/Image";
import CardActionsSkybox from "domains/assets/components/CardActions/Skybox";
import CardActionsTexture from "domains/assets/components/CardActions/Texture";
import CardActionsVideo from "domains/assets/components/CardActions/Video";

export {
  CardActions3D,
  CardActionsImage,
  CardActionsSkybox,
  CardActionsTexture,
  CardActionsVideo,
};
